export default __webpack_public_path__ + "static/media/trincheta-fondo.f4a931ed.jpg";